import React from 'react';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import PilotIcon from './PilotIcon';

export function accessPanelOpen(params: URLSearchParams) {
  if (params.get('panel') === 'closed') return false;
  if (params.get('panel') === 'open') return true;
  return params.get('tab') === 'roles' || params.get('tab') === 'audit' || Boolean(params.get('person'));
}
export function accessTabSearch(params: URLSearchParams, tab: string) {
  const next = new URLSearchParams(params);
  next.set('panel', accessPanelOpen(params) ? 'open' : 'closed');
  next.set('tab', tab);
  // Opening Roles/Audit from the initial full-width People list reveals their context.
  if (!params.has('panel') && !accessPanelOpen(params) && tab !== 'users') next.set('panel', 'open');
  return next;
}
export const accessGridColumns = (open: boolean) => open ? { xs: 'minmax(0,1fr)', md: '280px minmax(0,1fr)', lg: '340px minmax(0,1fr)', xl: '420px minmax(0,1fr)' } : { xs: 'minmax(0,1fr)' };
export function useAccessPanel() {
  const [params, setParams] = useSearchParams();
  return { open: accessPanelOpen(params), setOpen: (open: boolean) => { const next = new URLSearchParams(params); next.set('panel', open ? 'open' : 'closed'); setParams(next, { replace: true }); } };
}
export default function AccessPanelHeader() {
  const { setOpen } = useAccessPanel();
  return <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ height: 56 }}><Typography component="h2" fontSize={15} fontWeight={600}>Access</Typography><Tooltip title="Collapse Access panel"><IconButton size="small" aria-label="Collapse Access panel" onClick={() => setOpen(false)}><PilotIcon name="collapse" size={16} /></IconButton></Tooltip></Stack>;
}
